// src/App.js
import React from 'react';
import Home from './components/home.js'
import './App.css';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;